"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ActionBarStyled = require("./ActionBar-styled");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _ActionBar = require("./ActionBar");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Action = function Action(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      other = _objectWithoutProperties(_ref, ["children", "icon"]);

  var actionBarContext = (0, _react.useContext)(_ActionBar.ActionBarContext);

  var getIcon = function getIcon(icon) {
    return _react.default.cloneElement(icon, {
      size: 16
    });
  };

  var actionButton = _react.default.createElement(_ActionBarStyled.StyledAction, _extends({
    dark: actionBarContext.dark,
    collapsed: actionBarContext.collapsed,
    icon: getIcon(icon)
  }, other), !actionBarContext.collapsed && children);

  return actionBarContext.collapsed ? _react.default.createElement(_Tooltip.default, {
    title: children,
    placement: "right",
    targetWrapperStyle: _ActionBarStyled.TooltipWrapperStyles
  }, actionButton) : actionButton;
};

Action.propTypes = {
  /** The content of the component */
  children: _propTypes.default.node,

  /** Sets the action as the selected item in the ActionBar */
  active: _propTypes.default.bool
};
Action.defaultProps = {};
Action.displayName = 'Action';
var _default = Action;
exports.default = _default;